import Entity from '../entity'

export default class AdjustItem extends Entity<number>{
    adjid:string='0';
    adjno:string='';
    adjtype:string='1';
    createby:string='';
    checkby:string='';
    isposted:boolean=false;
}